export default "__VITE_ASSET__BBKvkO9d__"